<div *ngIf="!isRegistrationClosed">
    <div [innerHTML]="htmlStyles | trustAsHtml"></div>
    <div [ngClass]="ribbonStatusClass" [innerHTML]="htmlTextUpdated | trustAsHtml"></div>
</div>
